export async function requestStorePermissions(storeUuid) {
    let storeUuids = storeUuid;
    let storeUuidsToLoad = [];
    if(!Array.isArray(storeUuids)){
        storeUuids = [storeUuids];
    }

    for(let storeUuid of storeUuids){
        if (!this.$storePermissions.hasOwnProperty(storeUuid)) {
            storeUuidsToLoad.push(storeUuid);
        }
    }

    this.$storePermissions[storeUuid] = {};
    for(let key in this.StorePermission){
        this.$storePermissions[storeUuid][key] = false;
    }

    axios.post(this.$route('store_user.can'), {
        store_uuids: storeUuidsToLoad
    }).then(response => {
        for(let storeUuid in response.data.data){
            for (let permission of response.data.data[storeUuid]) {
                this.$storePermissions[storeUuid][permission] = true;
            }
        }
        this.$forceUpdate();
    });
}

export function can(permission, storeUuid = null) {
    if (storeUuid) {
        if (!this.$storePermissions.hasOwnProperty(storeUuid)) {
            return false;
        }

        if (!this.$storePermissions[storeUuid].hasOwnProperty(permission)) {
            return false;
        }

        return this.$storePermissions[storeUuid][permission];
    } else {
        return this.Permission[permission];
    }
}
